import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { motion } from "framer-motion";
import BackgroundVideo from "../components/Background-Video";
import BackButton from "../partials/Back-Button";
import Videos from "../video/101160_SCS_Interactive_Sc7_4K_10s_V5.mp4";
import Expenses from "../images/campus/expenses.png";
import Safety from "../images/campus/improve_safety.png";
import Improve from "../images/campus/improve.png";
import Elevated from "../images/campus/elevated_life.png";
import Modernize from "../images/campus/modernize_learning.png";


const PrivateMobilityCampus = () => {
  const [activeDot, setActiveDot] = useState("");
  const [dotOneX, setDotOneX] = useState();
  const [dotOneY, setDotOneY] = useState();
  const [blobOneX, setBlobOneX] = useState();
  const [blobOneY, setBlobOneY] = useState();
  const [dotTwoX, setDotTwoX] = useState();
  const [dotTwoY, setDotTwoY] = useState();
  const [blobTwoX, setBlobTwoX] = useState();
  const [blobTwoY, setBlobTwoY] = useState();
  const [dotThreeX, setDotThreeX] = useState();
  const [dotThreeY, setDotThreeY] = useState();
  const [blobThreeX, setBlobThreeX] = useState();
  const [blobThreeY, setBlobThreeY] = useState();
  const [dotFourX, setDotFourX] = useState();
  const [dotFourY, setDotFourY] = useState();
  const [blobFourX, setBlobFourX] = useState();
  const [blobFourY, setBlobFourY] = useState();
  const [dotFiveX, setDotFiveX] = useState();
  const [dotFiveY, setDotFiveY] = useState();
  const [blobFiveX, setBlobFiveX] = useState();
  const [blobFiveY, setBlobFiveY] = useState();

  const getPosition = () => {
    const dotOne = document.getElementById("dotOne").getBoundingClientRect();
    const dotOneTop = dotOne.top;
    const dotOneLeft = dotOne.left;

    setDotOneX(dotOneLeft + 21.5);
    setDotOneY(dotOneTop + 21.5);

    const blobOne = document.getElementById("blobOne").getBoundingClientRect();
    const blobOneTop = blobOne.top;
    const blobOneLeft = blobOne.left;

    setBlobOneX(blobOneLeft);
    setBlobOneY(blobOneTop);

    const dotTwo = document.getElementById("dotTwo").getBoundingClientRect();
    const dotTwoTop = dotTwo.top;
    const dotTwoLeft = dotTwo.left;

    setDotTwoX(dotTwoLeft + 21.5);
    setDotTwoY(dotTwoTop + 21.5);

    const blobTwo = document.getElementById("blobTwo").getBoundingClientRect();
    const blobTwoTop = blobTwo.top;
    const blobTwoLeft = blobTwo.left;

    setBlobTwoX(blobTwoLeft);
    setBlobTwoY(blobTwoTop);

    const dotThree = document
        .getElementById("dotThree")
        .getBoundingClientRect();
    const dotThreeTop = dotThree.top;
    const dotThreeLeft = dotThree.left;

    setDotThreeX(dotThreeLeft + 21.5);
    setDotThreeY(dotThreeTop + 21.5);

    const blobThree = document
        .getElementById("blobThree")
        .getBoundingClientRect();
    const blobThreeTop = blobThree.top;
    const blobThreeLeft = blobThree.left;

    setBlobThreeX(blobThreeLeft);
    setBlobThreeY(blobThreeTop);

    const dotFour = document.getElementById("dotFour").getBoundingClientRect();
    const dotFourTop = dotFour.top;
    const dotFourLeft = dotFour.left;

    setDotFourX(dotFourLeft + 21.5);
    setDotFourY(dotFourTop + 21.5);

    const blobFour = document
        .getElementById("blobFour")
        .getBoundingClientRect();
    const blobFourTop = blobFour.top;
    const blobFourLeft = blobFour.left;

    setBlobFourX(blobFourLeft);
    setBlobFourY(blobFourTop);

    const dotFive = document.getElementById("dotFive").getBoundingClientRect();
    const dotFiveTop = dotFive.top;
    const dotFiveLeft = dotFive.left;

    setDotFiveX(dotFiveLeft + 21.5);
    setDotFiveY(dotFiveTop + 21.5);

    const blobFive = document
        .getElementById("blobFive")
        .getBoundingClientRect();
    const blobFiveTop = blobFive.top;
    const blobFiveLeft = blobFive.left;

    setBlobFiveX(blobFiveLeft);
    setBlobFiveY(blobFiveTop);
  };

  useEffect(() => {
    getPosition();
  }, []);

  return (
      <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="w-screen h-[calc(100vh-120px)] 2xl:h-[calc(100vh-172px)] relative top-[120px] 2xl:top-[172px] left-0"
      >
        <BackButton backurl="/private-wireless" />
        <BackgroundVideo fullscreen video={Videos} />
        <div className="w-screen h-[calc(100vh-120px)] 2xl:h-[calc(100vh-172px)] relative ">
          <div className=" bg-opacity-50 backdrop-blur-md bg-white w-[574px] 2xl:w-[823px] py-7 px-9 2xl:py-14 2xl:px-[59px] rounded-3xl relative left-10 top-5 zoom-8">
            <h1 className="font-semibold uppercase text-dell-blue font-proxima-nova text-lg 2xl:text-[25px] 2xl:leading-[30px] pb-3">
              Campus
            </h1>
            <p className=" text-[#444444] text-xl 2xl:text-[30px] 2xl:leading-[37px] font-proxima-nova font-thin">
              Grow your managed services business and monetize your 5G investment
              through modernizing campuses and improving student and staff
              experience.
            </p>
          </div>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 1 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <motion.line
                x1={dotOneX}
                y1={dotOneY}
                x2={blobOneX}
                y2={blobOneY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 2 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <motion.line
                x1={dotTwoX}
                y1={dotTwoY}
                x2={blobTwoX}
                y2={blobTwoY}
                stroke="#444444"
                strokeDasharray="15 15"
                strokeDashoffset="15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 3 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <motion.line
                x1={dotThreeX}
                y1={dotThreeY}
                x2={blobThreeX}
                y2={blobThreeY}
                stroke="#444444"
                strokeDasharray="15 15"
                strokeDashoffset="15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 4 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <motion.line
                x1={dotFourX}
                y1={dotFourY}
                x2={blobFourX}
                y2={blobFourY}
                stroke="#444444"
                strokeDasharray="15 15"
                strokeDashoffset="15"
            />
          </svg>
          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 5 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <motion.line
                x1={dotFiveX}
                y1={dotFiveY}
                x2={blobFiveX}
                y2={blobFiveY}
                stroke="#444444"
                strokeDasharray="15 15"
                strokeDashoffset="15"
            />
          </svg>

          <div className="edge-dots absolute w-screen h-[calc(100vh-172px)] top-0 grid grid-cols-5 grid-rows-3">
            <div></div>
            <div className="relative flex justify-center items-start">
              <div
                  id="blobTwo"
                  className={classnames(
                      "absolute left-[500px] top-0 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-[#FFFFFF] min-w-[443px] h-[443px] transition-all duration-300 z-40",
                      activeDot === 2
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-[#FFFFFF] font-proxima-nova font-semibold pb-4">
                  Improve <br />
                  Operational Expenses:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  IoT sensors improve energy <br />
                  efficiency by wirelessly <br />
                  adjusting thermostats and lights <br />
                  based on occupancy.
                  <br />
                  <br />
                  Sensors can also anticipate <br />
                  utility faults and outages,
                  <br />
                  resulting in a more comfortable <br />
                  environment.
                </p>
                <img
                    src={Expenses}
                    alt=""
                    width="308"
                    className="absolute right-[95%]"
                />
              </div>
            </div>
            <div></div>
            <div className="relative flex ">
              <div
                  id="blobThree"
                  className={classnames(
                      "absolute right-[500px] top-0 px-10 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-[#FFFFFF] w-[350px] h-[350px] transition-all duration-300 z-40",
                      activeDot === 3
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-[#FFFFFF] font-proxima-nova font-semibold pb-4">
                  Improve Safety:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Leverage wireless <br />
                  security cameras to cover <br />a broad area over a
                  <br />
                  secure private network <br />
                  for increased visibility of <br />
                  grounds and timely <br />
                  emergency notifications.
                </p>
                <img
                    src={Improve}
                    alt=""
                    width="308"
                    className="absolute right-[95%]"
                />
              </div>
            </div>
            <div className="relative flex justify-center z-[50]">
              <div
                  id="blobFive"
                  className={classnames(
                      "absolute right-[500px] top-0 px-9 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-[#FFFFFF] min-w-[398px] h-[398px] transition-all duration-300 z-[9999999]",
                      activeDot === 5
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-[#FFFFFF] font-proxima-nova font-semibold pb-4">
                  Elevated Student Life:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  IoT sensors alert students when <br />
                  shared resources are free like
                  <br />
                  computers, parking spots or laundry.
                  <br />
                  <br />
                  Automated kiosks using contactless <br />
                  payment for food services provide <br />
                  added convenience for students <br />
                  and staff optimization.
                </p>
                <img
                    src={Elevated}
                    alt=""
                    width="308"
                    className="absolute right-[95%]"
                />
              </div>
            </div>

            <div className="relative flex justify-center">
              <div
                  id="dotOne"
                  onMouseEnter={() => setActiveDot(1)}
                  onMouseLeave={() => setActiveDot("")}
                  tabindex="0"
                  onKeyUp={() => setActiveDot(1)}
                  onKeyDown={() => setActiveDot("")}
                  className="dot top-[22%] 2xl:top-[15%] z-10 right-[36%] 2xl:right-[15%] cursor-pointer absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#6E2585] border-2"
              ></div>
            </div>
            <div className="relative flex justify-center items-start">
              <div
                  id="dotTwo"
                  onMouseEnter={() => setActiveDot(2)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(2)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
                  className="dot top-[22%] 2xl:top-[15%] z-10 cursor-pointer absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#6E2585] border-2"
              ></div>
            </div>
            <div className="relative flex justify-end">
              <div
                  id="blobFour"
                  className={classnames(
                      "absolute left-3/4 bottom-2/4 px-8 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-[#FFFFFF] w-[280px] h-[280px] transition-all duration-300",
                      activeDot === 4
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-[#FFFFFF] font-proxima-nova font-semibold pb-4">
                  Improve Safety:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  The use of smart ID <br />
                  cards helps improve <br />
                  control and <br />
                  management of <br />
                  campus facilities.
                </p>
                <img
                    src={Safety}
                    alt=""
                    width="308"
                    className="absolute right-[95%]"
                />
              </div>

              <div
                  id="dotThree"
                  onMouseEnter={() => setActiveDot(3)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(3)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
                  className="dot cursor-pointer z-10 absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] top-10 2xl:top-0 right-4 bg-[#6E2585] border-2"
              ></div>
              <div
                  id="dotFour"
                  onMouseEnter={() => setActiveDot(4)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(4)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
                  className="dot cursor-pointer z-10 absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] top-[64%] 2xl:top-[50%] right-20 2xl:right-32 bg-[#6E2585] border-2"
              ></div>
            </div>
            <div className="relative">
              <div
                  id="dotFive"
                  onMouseEnter={() => setActiveDot(5)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(5)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
                  className="dot cursor-pointer z-10 absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] top-0 right-0 bg-[#6E2585] border-2"
              ></div>
            </div>
            <div></div>

            <div></div>
            <div className="relative flex justify-center">
              <div
                  id="blobOne"
                  className={classnames(
                      "absolute left-[300px] bottom-16 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-[#FFFFFF] min-w-[443px] h-[443px] transition-all duration-300",
                      activeDot === 1
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-[#ffffff] font-proxima-nova font-semibold pb-4">
                  Modernize Learning:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Equip auditoriums and classrooms <br />
                  with smart boards, smart podiums <br />
                  and AR/VR gears for more <br />
                  interactive and productive learning.
                  <br />
                  <br />
                  Enable research of emerging <br />
                  technologies using a low latency
                  <br />
                  private network that can power <br />
                  robotics and drones in <br />
                  research centers.
                </p>
                <img
                    src={Modernize}
                    alt=""
                    width="308"
                    className="absolute right-[95%]"
                />
              </div>
            </div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </motion.div>
  );
};

export default PrivateMobilityCampus;
